if (!customElements.get('discovery-accordion')) {
  class DiscoveryAccordion extends HTMLElement {
    constructor() {
      super();
      this.onTriggerClick = this.onTriggerClick.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');

        if (!trigger || !panel) return;

        this.closeItem(item, trigger, panel);
        trigger.addEventListener('click', this.onTriggerClick);
      });
    }

    disconnectedCallback() {
      this.items?.forEach((item) => {
        const trigger = item.querySelector('[data-accordion-trigger]');
        trigger?.removeEventListener('click', this.onTriggerClick);
      });
    }

    onTriggerClick(event) {
      const trigger = event.currentTarget;
      const item = trigger.closest('[data-accordion-item]');
      const panel = item?.querySelector('[data-accordion-panel]');

      if (!item || !panel) return;

      const isOpen = item.classList.contains('is-open');

      this.closeAll();

      if (!isOpen) {
        this.openItem(item, trigger, panel);
      }
    }

    closeAll() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');
        if (trigger && panel) {
          this.closeItem(item, trigger, panel);
        }
      });
    }

    openItem(item, trigger, panel) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    }

    closeItem(item, trigger, panel) {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.maxHeight = '0';
    }
  }

  customElements.define('discovery-accordion', DiscoveryAccordion);
}
